import type { Corral, Pasture, Retreat } from "shared/types";

export const LIST_FARM_CORRALS = "LIST_FARM_CORRALS";
export const LIST_FARM_PASTURES = "LIST_FARM_PASTURES";
export const LIST_FARM_RETREATS = "LIST_FARM_RETREATS";

export type PastureDispatchAction =
  | {
      type: typeof LIST_FARM_CORRALS;
      payload: { corrals: Corral[] };
    }
  | {
      type: typeof LIST_FARM_PASTURES;
      payload: { pastures: Pasture[] };
    }
  | {
      type: typeof LIST_FARM_RETREATS;
      payload: { retreats: Retreat[] };
    };

export const listFarmCorrals = (corrals: Corral[]): PastureDispatchAction => {
  return {
    type: LIST_FARM_CORRALS,
    payload: { corrals },
  };
};

export const listFarmPastures = (
  pastures: Pasture[]
): PastureDispatchAction => {
  return {
    type: LIST_FARM_PASTURES,
    payload: { pastures },
  };
};

export const listFarmRetreats = (
  retreats: Retreat[]
): PastureDispatchAction => {
  return {
    type: LIST_FARM_RETREATS,
    payload: { retreats },
  };
};
